(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/divider/views/divider-tur.js') >= 0) return;  svs.modules.push('/components/content/divider/views/divider-tur.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.content=_svs.content||{};
_svs.content.divider=_svs.content.divider||{};
_svs.content.divider.templates=_svs.content.divider.templates||{};
svs.content.divider.templates.divider_tur = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"eurojackpot"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"lotto"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"keno"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"kenoxpress"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"vikinglotto"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"rubbet"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"triss"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"skrapspel"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"lordagsgodis"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"3irad"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"mittemellan"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"17ellermer"},"data":data}));
},"useData":true});
Handlebars.partials['components-content-divider-divider_tur'] = svs.content.divider.templates.divider_tur;
})(svs, Handlebars);

 })(window);